module.exports = __webpack_public_path__ + "img/spiral-details21.5657a557.png";